// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/types/inline_comments.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "api.devplan.types.inline_comments";

/**
 * InlineComment represents a comment made to a document with an optional reference to a text selection.
 * Note: absent of the document it references, it does not exist on its own
 */
export interface InlineComment {
  /**
   * CUID identifying this comment:
   * either in the database if part of a DB record, or client-side UUID if it hasn't been persisted yet
   */
  id: string;
  /** If the comment is made on a selected area of text, this field captures that selection. */
  selection?:
    | InlineCommentSelection
    | undefined;
  /** The comment text content. */
  content: string;
  /** CUID of the comment author. */
  authorId: string;
}

export interface InlineCommentSelection {
  /** Start position of text selection (0-based JavaScript UTF-16 code unit index). */
  startOffset: number;
  /** End position of text selection (0-based JavaScript UTF-16 code unit index). Must be > start_offset. */
  endOffset: number;
  /** The exact text that was selected when creating the anchor. */
  anchorText: string;
}

function createBaseInlineComment(): InlineComment {
  return { id: "", selection: undefined, content: "", authorId: "" };
}

export const InlineComment: MessageFns<InlineComment> = {
  encode(message: InlineComment, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.selection !== undefined) {
      InlineCommentSelection.encode(message.selection, writer.uint32(18).fork()).join();
    }
    if (message.content !== "") {
      writer.uint32(26).string(message.content);
    }
    if (message.authorId !== "") {
      writer.uint32(34).string(message.authorId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InlineComment {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInlineComment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.selection = InlineCommentSelection.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.content = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.authorId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InlineComment {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      selection: isSet(object.selection) ? InlineCommentSelection.fromJSON(object.selection) : undefined,
      content: isSet(object.content) ? globalThis.String(object.content) : "",
      authorId: isSet(object.authorId)
        ? globalThis.String(object.authorId)
        : isSet(object.author_id)
        ? globalThis.String(object.author_id)
        : "",
    };
  },

  toJSON(message: InlineComment): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.selection !== undefined) {
      obj.selection = InlineCommentSelection.toJSON(message.selection);
    }
    if (message.content !== "") {
      obj.content = message.content;
    }
    if (message.authorId !== "") {
      obj.authorId = message.authorId;
    }
    return obj;
  },

  create(base?: DeepPartial<InlineComment>): InlineComment {
    return InlineComment.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<InlineComment>): InlineComment {
    const message = createBaseInlineComment();
    message.id = object.id ?? "";
    message.selection = (object.selection !== undefined && object.selection !== null)
      ? InlineCommentSelection.fromPartial(object.selection)
      : undefined;
    message.content = object.content ?? "";
    message.authorId = object.authorId ?? "";
    return message;
  },
};

function createBaseInlineCommentSelection(): InlineCommentSelection {
  return { startOffset: 0, endOffset: 0, anchorText: "" };
}

export const InlineCommentSelection: MessageFns<InlineCommentSelection> = {
  encode(message: InlineCommentSelection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.startOffset !== 0) {
      writer.uint32(8).int32(message.startOffset);
    }
    if (message.endOffset !== 0) {
      writer.uint32(16).int32(message.endOffset);
    }
    if (message.anchorText !== "") {
      writer.uint32(26).string(message.anchorText);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InlineCommentSelection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInlineCommentSelection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.startOffset = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.endOffset = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.anchorText = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InlineCommentSelection {
    return {
      startOffset: isSet(object.startOffset)
        ? globalThis.Number(object.startOffset)
        : isSet(object.start_offset)
        ? globalThis.Number(object.start_offset)
        : 0,
      endOffset: isSet(object.endOffset)
        ? globalThis.Number(object.endOffset)
        : isSet(object.end_offset)
        ? globalThis.Number(object.end_offset)
        : 0,
      anchorText: isSet(object.anchorText)
        ? globalThis.String(object.anchorText)
        : isSet(object.anchor_text)
        ? globalThis.String(object.anchor_text)
        : "",
    };
  },

  toJSON(message: InlineCommentSelection): unknown {
    const obj: any = {};
    if (message.startOffset !== 0) {
      obj.startOffset = Math.round(message.startOffset);
    }
    if (message.endOffset !== 0) {
      obj.endOffset = Math.round(message.endOffset);
    }
    if (message.anchorText !== "") {
      obj.anchorText = message.anchorText;
    }
    return obj;
  },

  create(base?: DeepPartial<InlineCommentSelection>): InlineCommentSelection {
    return InlineCommentSelection.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<InlineCommentSelection>): InlineCommentSelection {
    const message = createBaseInlineCommentSelection();
    message.startOffset = object.startOffset ?? 0;
    message.endOffset = object.endOffset ?? 0;
    message.anchorText = object.anchorText ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
